import {
    Notification,
    NotificationDataType,
    InterfaceElementUnreadNotificationData,
    NOTIFICATION_TYPE,
    TEACHER_HEADER_MENU_ITEMS,
} from '@yandex-int/k-common/typings';

export const isInterfaceElementUnreadNotification = (
    notification: Notification<NotificationDataType>
): notification is Notification<InterfaceElementUnreadNotificationData> => {
    return notification.type_slug === NOTIFICATION_TYPE.INTERFACE_ELEMENT_UNREAD;
};

export const getNotificationIdByElementId = (
    notifications: Array<Notification<InterfaceElementUnreadNotificationData>>,
    elementId?: TEACHER_HEADER_MENU_ITEMS
) => notifications.find((notification) => notification.data.element_identifier === elementId)?.id;

export const getCurrentMenuNotifications = (
    notifications: Array<Notification<NotificationDataType>>,
    currentMenuItems: TEACHER_HEADER_MENU_ITEMS[]
) => {
    const currentMenuNotifications: Array<Notification<InterfaceElementUnreadNotificationData>> = [];

    notifications.forEach((notification) => {
        if (isInterfaceElementUnreadNotification(notification)) {
            const {
                data: { element_identifier },
            } = notification;

            if (currentMenuItems.includes(element_identifier)) {
                currentMenuNotifications.push(notification);
            }
        }
    });

    return currentMenuNotifications;
};
